import commonConstant from '../../common/_commonConstant';

export const getParkingDayConfig = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_PARKING_DAY_CONFIG_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_PARKING_DAY_CONFIG_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const updateParkingDayConfig = (state, action) => {
  switch (action.type) {
    case commonConstant.UPDATE_PARKING_DAY_CONFIG_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.UPDATE_PARKING_DAY_CONFIG_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const createParkingDayConfig = (state, action) => {
  switch (action.type) {
    case commonConstant.CREATE_PARKING_DAY_CONFIG_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.CREATE_PARKING_DAY_CONFIG_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
